
const fetchPDF = async (assetObject, token = null) => {
    if(assetObject.pdfPath){
      const filePath = assetObject?.pdfPath;
      const pathparts = filePath.split('/');
      const filename =  pathparts.pop();
      const foldername = pathparts.pop();
      const firstDashIndex = filename.indexOf('-');
      let actualFileName = ""
      if (firstDashIndex === -1) {
        actualFileName = filename;
      } else{
        actualFileName = filename.substring(firstDashIndex + 1);
      }
      try{
        const url = `${process.env.REACT_APP_BASE_URL}/upload/files/${foldername}/${filename}`;
        
        const headers = {
          'Content-Type': 'application/json',
        };
        
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
        
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const blob = await response.blob();
        const finalFile = new File([blob], actualFileName, { type: 'application/pdf' });
        return finalFile;
      } catch(error){
        console.error('fetchPDF: Error fetching file:', error);
        return null; // Return null on error instead of undefined
      }
    }
    return null; // Return null if no pdfPath
}

export default fetchPDF;